import React, { useState } from 'react';
import { Button } from '../../../ui/button';
import { Upload, Download } from 'lucide-react';

const ReportTab = ({ caseId, caseData, onRefresh, token }) => {
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState(null);

  const report = caseData?.report;

  const handleUpload = async () => {
    if (!file) {
      alert('Bitte PDF auswählen');
      return;
    }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/report/upload`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      setFile(null);
      onRefresh();
      alert('Hochgeladen');
    } catch (error) {
      alert('Upload fehlgeschlagen');
    } finally {
      setUploading(false);
    }
  };

  const toggleVisibility = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/report/visibility`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ visible_to_partner: !report.visible_to_partner })
      });
      onRefresh();
    } catch {
      alert('Fehler');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">PDF Upload</h3>
        <input type="file" accept=".pdf" onChange={e => setFile(e.target.files[0])} className="mb-3" />
        <Button onClick={handleUpload} disabled={uploading || !file} className="bg-brand-green text-white">
          <Upload className="w-4 h-4 mr-2" />
          {uploading ? 'Hochladen...' : 'PDF hochladen'}
        </Button>
      </div>

      {report && report.versions && report.versions.length > 0 && (
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-bold text-gray-900">Versionen</h3>
            <label className="flex items-center gap-2">
              <input type="checkbox" checked={report.visible_to_partner} onChange={toggleVisibility} />
              <span className="text-sm">Für Partner sichtbar</span>
            </label>
          </div>
          <div className="space-y-2">
            {report.versions.map(v => (
              <div key={v.upload_id} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-semibold text-sm">Version {v.version}</p>
                  <p className="text-xs text-gray-600">{new Date(v.uploaded_at).toLocaleDateString('de-DE')}</p>
                </div>
                <a href={`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/report/download?version=${v.version}`} className="text-brand-green hover:underline text-sm">
                  <Download className="w-4 h-4 inline mr-1" />Download
                </a>
              </div>
            ))}
          </div>
          {report.visible_to_partner && (
            <p className="text-xs text-green-600 mt-4">✓ Partner kann herunterladen</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ReportTab;
